import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { useCssVars as _useCssVars } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
};
const _hoisted_2 = ["onClick"];
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { generateTitle } from '@/utils/i18n.js';
export default {
  __name: 'index',
  setup(__props) {
    _useCssVars(_ctx => ({
      "v0542450e": linkHoverColor.value
    }));
    const route = useRoute();
    const breadcrumbData = ref([]);
    const getBreadcrumbData = () => {
      breadcrumbData.value = route.matched.filter(
      // 这个matched会返回当前路由及其所有的父级路由
      item => item.meta && item.meta.title);
    };
    watch(route, () => {
      getBreadcrumbData();
    }, {
      immediate: true
    });
    const router = useRouter();
    const onLinkClick = item => {
      router.push(item.path);
    };
    const store = useStore();
    const linkHoverColor = ref(store.getters.cssVar.menuBg);
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        class: "breadcrumb",
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_TransitionGroup, {
          name: "breadcrumb"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbData.value, (item, index) => {
            return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path
            }, {
              default: _withCtx(() => [index === breadcrumbData.value.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(generateTitle)(item.meta.title)), 1)) : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "redirect",
                onClick: _withModifiers($event => onLinkClick(item), ["prevent"])
              }, _toDisplayString(_unref(generateTitle)(item.meta.title)), 9, _hoisted_2))]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};